import axios from "axios";

const axiosInstance = axios.create({
  // baseURL: import.meta.env.VITE_LOCALHOST,
  baseURL: import.meta.env.VITE_BACKEND_URL,
});

// Automatically attach token from localStorage
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token && config.headers) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error),
);

export default axiosInstance;
